import {getFunctions,httpsCallable,connectFunctionsEmulator} from '@firebase/functions';
import firebase from '../helpers/firebase'


const functions=getFunctions();

if(process.env.NODE_ENV==='development') {
    connectFunctionsEmulator(functions,"127.0.0.1",5002);
}

const createOrUpdateProject=httpsCallable(functions,'createOrUpdateProject');
const deleteProject=httpsCallable(functions,'deleteProject');
const getProjects=httpsCallable(functions,'getProjects');
const getProject=httpsCallable(functions,'getProject');
const getCredits=httpsCallable(functions,'getCredits');
const createPortalLink=httpsCallable(functions,'ext-firestore-stripe-payments-createPortalLink')
const getStructuredCompletion=httpsCallable(functions,'aiFunctions-getStructuredCompletion');
const getStructuredSuggestions=httpsCallable(functions,'aiFunctions-getStructuredSuggestions');
const getStructuredChat=httpsCallable(functions,'aiFunctions-getStructuredChat');
const getStructuredGeneration=httpsCallable(functions,'aiFunctions-getStructuredGeneration');
const unifiedAgent=httpsCallable(functions,'aiFunctions-unifiedAgent');
// Sprint 1.5: Agentic chat with multi-step tool execution
const agenticChat=httpsCallable(functions,'aiFunctions-agenticChat',{timeout: 540000});
const continueAgentLoop=httpsCallable(functions,'aiFunctions-continueAgentLoop',{timeout: 540000});
const scheduleAccountDeletion=httpsCallable(functions,'scheduleAccountDeletion');
const cancelAccountDeletion=httpsCallable(functions,'cancelAccountDeletion');
const exportUserData=httpsCallable(functions,'exportUserData');

export {createOrUpdateProject,deleteProject,getProject,getCredits,createPortalLink,getProjects,getStructuredCompletion,getStructuredSuggestions,getStructuredChat,getStructuredGeneration,unifiedAgent,agenticChat,continueAgentLoop,scheduleAccountDeletion,cancelAccountDeletion,exportUserData};
